export type SpellId =
  | "fireball"
  | "ice-spike"
  | "lightning"
  | "shield"
  | "heal"
  | "teleport";

export type SpellDefinition = {
  id: SpellId;
  label: string;
  key: number;
  mana: number;
  cooldownMs: number;
  damage: number;
  speed: number;
  tint: number;
};

export const SPELLS: readonly SpellDefinition[] = [
  { id: "fireball", label: "FIREBALL", key: 1, mana: 45, cooldownMs: 650, damage: 95, speed: 720, tint: 0xff7a22 },
  { id: "ice-spike", label: "ICE SPIKE", key: 2, mana: 55, cooldownMs: 900, damage: 130, speed: 820, tint: 0x7fdcff },
  { id: "lightning", label: "LIGHTNING", key: 3, mana: 75, cooldownMs: 2400, damage: 115, speed: 0, tint: 0x8eb9ff },
  { id: "shield", label: "SHIELD", key: 4, mana: 90, cooldownMs: 7000, damage: 0, speed: 0, tint: 0xb278ff },
  { id: "heal", label: "HEAL", key: 5, mana: 120, cooldownMs: 9000, damage: 0, speed: 0, tint: 0x65dd83 },
  { id: "teleport", label: "TELEPORT", key: 6, mana: 80, cooldownMs: 4500, damage: 0, speed: 0, tint: 0xc68cff },
] as const;

export function spellByNumber(number: number): SpellDefinition | undefined {
  return SPELLS.find((spell) => spell.key === number);
}
